import { executePost } from '@/services/lukita'
import type {
  BlobInput,
  CalculateChecksum,
  PresignBlobs,
  PresignedBlob,
} from '../../types'

const presignBlobs = async (blobs: BlobInput[]): Promise<PresignedBlob[]> => {
  const response = await executePost('/blobs/presign', { blobs })
  return response.json()
}

export const presignBlobsFactory = (
  calculateChecksum: CalculateChecksum,
): PresignBlobs => {
  return async (files) => {
    const filesInput: BlobInput[] = await Promise.all(
      files.map(async (file) => ({
        checksum: await calculateChecksum(file),
        filename: file.name,
        content_type: file.type,
        byte_size: file.size,
      })),
    )

    return presignBlobs(filesInput)
  }
}
